import { BillingCredits } from '@/components/billing/billing-credits';
import { BillingInformation } from '@/components/billing/billing-information';
import { BillingOverview } from '@/components/billing/billing-overview';
import { BillingTrialEnd } from '@/components/billing/billing-trial-end';
import { BillingUsage } from '@/components/billing/billing-usage';
import { SettingsSectionHeader } from '@/components/settings/section-header';
import { Layout } from '@/components/ui/design-system';
import { useTeamSubscriptionData } from '@/hooks/api/team';
import { useCreditsEnabled } from '@/hooks/api/use-billing-credits';
import { useTranslation } from '@/hooks/use-translation';
import amplitudeService from '@/services/amplitude';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/billing/')({
  component: BillingRoute,
  onEnter: () => {
    amplitudeService.logEvent('Billing Tab Opened');
  },
});

function BillingRoute() {
  const { t } = useTranslation('desktop_ui');
  const { creditsEnabled } = useCreditsEnabled();
  const { isTrial } = useTeamSubscriptionData();

  return (
    <Layout isScrollable contentClassName="max-w-[960px] px-20 !pt-0 pb-30">
      <section className="flex flex-col gap-6">
        <SettingsSectionHeader
          title={t('settings.sidebar.billing')}
          description={t('settings.billing.page.description')}
        />
        <BillingOverview />
      </section>
      <BillingInformation />
      {isTrial && <BillingTrialEnd />}
      {creditsEnabled && <BillingCredits />}
      {creditsEnabled && <BillingUsage />}
    </Layout>
  );
}
